"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseLoanQueryRequest = void 0;
var UseLoanQueryRequest = /** @class */ (function () {
    function UseLoanQueryRequest() {
    }
    return UseLoanQueryRequest;
}());
exports.UseLoanQueryRequest = UseLoanQueryRequest;
//# sourceMappingURL=useLoanQuery.request.js.map